import React from "react";

export const NewMessagesDivider: React.FC = () => {
	return (
		<div className="relative flex items-center my-4 px-5">
			<div className="flex-1 h-px bg-gray-300" />
			<div className="px-3">
				<span className="text-xs font-medium text-blue-600 bg-blue-50 px-2 py-1 rounded-full">
					Neu
				</span>
			</div>
			<div className="flex-1 h-px bg-gray-300" />
		</div>
	);
};